import React, { useState, useEffect } from 'react';
import Select from "react-select";
import ListaDetalles from './ListaDetalles';
import { BotonAddItem } from '../../Plantillas/Botones';
import { notificarMsg, notificarError } from '../../Almacenes/AlmacenNotify';
import swal from "sweetalert";

export default function Form({ action, currentId, onCancel, onSaveSuccess = () => { } }) {
  const [nombre, setNombre] = useState("");
  const [codigoBarra, setCodigoBarra] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [idModelo, setIdModelo] = useState("");
  const [detalles, setDetalles] = useState([]);
  const [modelos, setModelos] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchModelos();
    if (currentId) {
      loadReceta(currentId);
    }
  }, [currentId]);

  const fetchModelos = async () => {
    try {
      const res = await fetch('/api/vidrieria/modelos?estado=ACTIVO');
      const data = await res.json();
      setModelos(data);
      if (!currentId && data.length > 0 && !idModelo) {
        setIdModelo(data[0].IdModelo);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const loadReceta = async (id) => {
    try {
      const res = await fetch(`/api/vidrieria/recetas/${id}`);
      if (res.ok) {
        const data = await res.json();
        setNombre(data.Nombre);
        setCodigoBarra(data.CodigoBarra || "");
        setDescripcion(data.Descripcion || "");
        setIdModelo(data.IdModelo);
        if (data.detalles) {
          setDetalles(data.detalles.map(d => ({
            ...d,
            ConfiguracionJSON: typeof d.ConfiguracionJSON === 'object'
              ? JSON.stringify(d.ConfiguracionJSON)
              : (d.ConfiguracionJSON || "{}")
          })));
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  const searchProduct = async (search) => {
    if (!search) return [];
    try {
      const req = await fetch(`/api/preVentas/?search=${search}&idTipoStock=1`);
      if (req.ok) {
        const data = await req.json();
        return data.productos.map(p => ({
          value: p.IdPresentacion,
          label: `${p.descripcion} ${p.unidadMedida || ''}`,
          codigoBarra: p.codigoBarra
        }));
      }
    } catch (e) {
      console.error(e);
    }
    return [];
  };

  const onSaveForm = async () => {
    if (!nombre) return notificarError("El nombre es requerido");
    if (!idModelo) return notificarError("Debe seleccionar un modelo");

    setLoading(true);
    const payload = {
      IdModelo: idModelo,
      Nombre: nombre,
      CodigoBarra: codigoBarra,
      Descripcion: descripcion,
      detalles: detalles.map(d => ({
        IdPresentacion: d.IdPresentacion,
        NombrePieza: d.NombrePieza,
        CodigoBarra: d.CodigoBarra,
        ConfiguracionJSON: typeof d.ConfiguracionJSON === 'string' ? JSON.parse(d.ConfiguracionJSON) : (d.ConfiguracionJSON || {})
      }))
    };

    try {
      const url = currentId ? `/api/vidrieria/recetas/${currentId}` : '/api/vidrieria/recetas';
      const method = currentId ? 'PATCH' : 'POST';

      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!res.ok) throw new Error("Error saving receta");

      notificarMsg("Receta guardada exitosamente");
      onSaveSuccess();
      onCancel();
    } catch (e) {
      console.error(e);
      notificarError("Ocurrió un error al guardar la receta");
    } finally {
      setLoading(false);
    }
  };

  const selectedModeloObj = modelos.find(m => m.IdModelo === idModelo);
  const variablesConfig = selectedModeloObj && selectedModeloObj.VariablesConfig 
    ? (typeof selectedModeloObj.VariablesConfig === 'string' ? JSON.parse(selectedModeloObj.VariablesConfig) : selectedModeloObj.VariablesConfig)
    : [];

  return (
    <div className="container">
      <div className="row">
        <div className="col-12 col-md-6 mt-2">
          <div className="form-group">
            <label>Modelo Base:</label>
            <Select
              options={modelos.map(m => ({ value: m.IdModelo, label: m.Nombre }))}
              value={idModelo ? { value: idModelo, label: modelos.find(m => m.IdModelo === idModelo)?.Nombre } : null}
              onChange={e => setIdModelo(e ? e.value : "")}
              isClearable={true}
              placeholder="Buscar modelo..."
            />
          </div>
          <div className="p-3 bg-light text-center d-flex justify-content-center align-items-center" style={{ border: '1px dashed #ccc', minHeight: '200px' }}>
            {selectedModeloObj && selectedModeloObj.SvgBase ? (
              <div dangerouslySetInnerHTML={{ __html: selectedModeloObj.SvgBase }} style={{ maxWidth: '100%', maxHeight: '100%' }} />
            ) : (
              <span className="text-muted">Sin diseño SVG</span>
            )}
          </div>
        </div>

        <div className="col-12 col-md-6 mt-2">
          <div className="row">
            <div className="col-12 col-md-6 mb-2">
              <label>Nombre de la Receta:</label>
              <input
                className="form-control"
                type="text"
                value={nombre}
                onChange={e => setNombre(e.target.value)}
              />
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label>Código de Barras:</label>
              <input
                className="form-control"
                type="text"
                value={codigoBarra}
                onChange={e => setCodigoBarra(e.target.value)}
              />
            </div>
            <div className="col-12 mb-2">
              <label>Descripción:</label>
              <textarea
                className="form-control"
                rows="2"
                value={descripcion}
                onChange={e => setDescripcion(e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className="col-12 mt-4 border-top pt-3">
          <ListaDetalles
            detalles={detalles}
            onUpdateDetalle={setDetalles}
            variablesConfig={variablesConfig}
            searchProduct={searchProduct}
            tipoProducto={selectedModeloObj?.TipoProducto}
          />
        </div>

        <div className="col-12 mt-4 d-flex justify-content-end">
          <button type="button" className="btn btn-secondary mr-2" onClick={onCancel} disabled={loading}>Cancelar</button>
          <button type="button" className="btn btn-info" onClick={onSaveForm} disabled={loading}>
            {loading ? "Guardando..." : "Guardar Receta"}
          </button>
        </div>
      </div>
    </div>
  );
}
